import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { keywordReplyCreate, keywordReplyUpdate } from "@/api/customerCenter/customerCenter";
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
export default {
  name: 'addKeyWordsItem',
  mixins: [tabulation, gmToolNewPage, gmTool],
  props: {
    gameList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        reply_content: "",
        keyword: [],
        status: 1,
        game: ''
      },
      reqLoading: false,
      rules: {
        reply_content: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        status: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }] // value: [{ required: true, message: "请输入参数", trigger: "blur" }],

      }
    };
  },
  created: function created() {},
  methods: {
    open: function open(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (row) {
                  data = _objectSpread({}, row);
                  console.log("data==", data);
                  data.keyword = data.keyword ? data.keyword.split(",").map(function (v) {
                    return {
                      value: v
                    };
                  }) : [];
                  _this.formData = _objectSpread({}, data);
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addContent: function addContent() {
      this.formData.keyword.push({
        value: ''
      });
    },
    removeContent: function removeContent(item) {
      var index = this.formData.keyword.indexOf(item);

      if (index !== -1) {
        this.formData.keyword.splice(index, 1);
      }
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this2.reqLoading = true;
          var data = JSON.parse(JSON.stringify(_this2.formData));
          console.log("data==", data);
          data.keyword = data.keyword.length ? data.keyword.map(function (item) {
            return item.value;
          }).join(',') : '';
          data.game_id = _this2.rawData.game_id;
          var req = _this2.formData.id ? keywordReplyUpdate : keywordReplyCreate;
          req(data).then(function (res) {
            _this2.reqLoading = false;

            if (res.code == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          }).finally(function () {
            _this2.reqLoading = false;
          });
        }
      });
    },
    clearData: function clearData() {
      var _this3 = this;

      this.formData = {
        id: "",
        reply_content: "",
        keyword: [],
        status: "1",
        game: ''
      };
      this.$nextTick(function () {
        _this3.$refs.ruleForm.resetFields();
      });
    }
  }
};